/**
 * i18n 기본 셋팅
 */
import Vue from 'vue'
import envs from '@/envs'
import localStore from '@/utils/localStore'
import VueI18n from 'vue-i18n'
import { getI18nSet } from '@/api/common/lang.js'

Vue.use(VueI18n)

// 유틸리티에서 사용자가 정의한 locale 정보를 가져온다.
var locale = localStore.get('locale')
// 이전에 설정한 locale 정보가 없을 경우, envs에 셋팅된 값을 가져온다.
if (!locale) {
  locale = envs.framework.locale
}

// 기본 문자열 셋 값을 구성한다.
let messages = {}
envs.framework.supportLocales.forEach(targetLocale => {
  messages[targetLocale.id] = require('./' + targetLocale.id).default
})

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en', // 값이 없을 경우 기본으로 설정되는 locale
  messages,
  silentTranslationWarn: true
})

VueI18n.prototype.getInitLocale = function () {
  return locale
}

// 서버에서 i18n 메시지 값을 가져와 반영한다.
// 서버에서 다국어 메시지를 가져와 처리해야할 경우 적용한다.
export function setI18n () {
  envs.framework.supportLocales.forEach(targetLocale => {
    // 가지고 있는 locale에 따라 i18n 셋팅을 한다.
    getI18nSet(targetLocale.id).then(msgs => {
      // 가져온 값 리스트를 Object 형태로 재 구성한다.
      let setObj = {}
      msgs.forEach(msg => {
        setObj[msg.id] = msg.text
      })

      i18n.setLocaleMessage(targetLocale.id, setObj)
    })
  })
}

// 서버 조회 설정이 있을 경우
if (envs.framework.getI18nDataFromServer) {
  setI18n()
}

export default i18n
